export const isActiveLarge = (summaryData, legendItemCode) => {
    // Get codes for left column values of legend table (payment comparison)
    const codeSelectors = ['subject', 'club', 'partners']
    // Get codes that are active for specified row (legend item code)
    const activeCodes = codeSelectors.map((x) => summaryData?.[x]?.code).filter((x) => x === legendItemCode)

    // If two or more codes are active - row has bigger height
    if (activeCodes.length >= 2) return true

    return false
}
